import { useEffect, useState } from 'react';

import { apiContainer } from '@vlabs/api-bindings';
import { selectListOptions, selectLists } from '@vlabs/shared/selectors/listSelectors';
import { useSelector } from 'react-redux';

const cache = {};

export const useMatchData = (matchData) => {
  const type = matchData?.face_id ? 'face' : 'event';
  const dataId = matchData?.face_id ?? matchData?.event_id;

  const [match, setMatch] = useState(undefined);

  const lists = useSelector(selectLists);
  const listOptions = useSelector(selectListOptions);

  useEffect(() => {
    if (!dataId) {
      setMatch(undefined);
      return;
    }

    if (cache[dataId] !== undefined) {
      setMatch(cache[dataId]);
      return;
    }

    apiContainer.lunaClient[type === 'face' ? 'faces' : 'events'].get(dataId).then(({ data }) => {
      setMatch({
        ...data,
        lists: data.lists?.map((faceListId) => lists.byId[faceListId] || faceListId),
        listOptions: data.lists?.map((faceListId) => listOptions
          .find(({ value }) => value === faceListId) || { label: faceListId, value: faceListId }),
      });
    }).catch(() => { setMatch(undefined); });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataId]);

  return [match, type];
};
